import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=a45bd680&"
import script from "./ModuleEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports